<!--
 * @Author: cmchiu
 * @Date: 2022-05-05 14:27:05
 * @LastEditTime: 2022-06-24 16:16:25
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\views\Activities.vue
 * 
-->
<template>
    <div class="activities">
        <section class="padding-bottom padding-top bg_img">
            <div class="container">
                <div class="col-lg-12 mt-20">
                    <breadcrumb />
                </div>

                <new-active height="calc(100vh - 100px)"
                            pageSize="12" />
            </div>
        </section>
    </div>
</template>

<script>
import { newActive } from '@c/NewActive'
import { breadcrumb } from '@c/Breadcrumb'

export default {
    name: 'activities',

    components: { newActive, breadcrumb },

    data: function () {
        return {}
    },

    created: function () {},

    methods: {},
}
</script>
